"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _PageManager = _interopRequireDefault(require("./PageManager"));
var _AnalyticsContext = require("./context/AnalyticsContext");
var _AuthContext = require("./context/AuthContext");
var _AppToaster = _interopRequireDefault(require("./components/common/AppToaster"));
var _ChatContext = require("./context/ChatContext");
var _DocumentPageContext = require("./context/DocumentPageContext");
var _ProposalEditsContext = require("./context/ProposalEditsContext");
var _WordDocumentContext = require("./context/WordDocumentContext");
var _ReviewedDocumentContext = require("./context/ReviewedDocumentContext");
var _RedlineAuthorColorsContext = require("./context/RedlineAuthorColorsContext");
var _BulkApplyRunContext = require("./context/BulkApplyRunContext");
var _BulkApplyPanel = require("./components/redline/BulkApplyPanel");
var _SavedPromptsContext = require("./context/SavedPromptsContext");
var _SavedFilesContext = require("./context/SavedFilesContext");
var _LoggedOutPage = _interopRequireDefault(require("./pages/LoggedOutPage"));
var _PageContext = require("./context/PageContext");
var _IcertisAuthPage = _interopRequireDefault(require("./pages/IcertisAuthPage"));
var _IcertisCallbackPage = _interopRequireDefault(require("./pages/IcertisCallbackPage"));
var _Banner = _interopRequireDefault(require("./components/common/Banner"));
var _ReauthModal = _interopRequireDefault(require("./components/auth/ReauthModal"));
var _SessionExpiryLogout = _interopRequireDefault(require("./components/auth/SessionExpiryLogout"));
var _AddinAiNoticeGate = _interopRequireDefault(require("./components/notice/AddinAiNoticeGate"));
var _WopiContext = require("./context/WopiContext");
var _WopiSessionLifecycle = _interopRequireDefault(require("./components/wopi/WopiSessionLifecycle"));
var _anchorTrackerRegistry = require("./utils/anchor/anchor-tracker-registry");
var _sentryReporter = require("./utils/sentry-reporter");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var AppContent = function AppContent() {
  var _useWordDocument = (0, _WordDocumentContext.useWordDocument)(),
    isWriteRestricted = _useWordDocument.isWriteRestricted;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    showWriteRestrictedBanner = _useState2[0],
    setShowWriteRestrictedBanner = _useState2[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isWriteRestricted && showWriteRestrictedBanner && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Banner.default, {
      type: "warning",
      message: "This document has protection enabled. Our add-in may have problems writing changes to it.",
      onDismiss: function onDismiss() {
        return setShowWriteRestrictedBanner(false);
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PageManager.default, {
      "data-sentry-element": "PageManager",
      "data-sentry-source-file": "App.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_BulkApplyPanel.BulkApplyPanel, {
      "data-sentry-element": "BulkApplyPanel",
      "data-sentry-source-file": "App.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppToaster.default, {
      "data-sentry-element": "AppToaster",
      "data-sentry-source-file": "App.tsx"
    })]
  });
};
var AuthenticatedApp = function AuthenticatedApp() {
  var _useAuthInfo = (0, _AuthContext.useAuthInfo)(),
    authStatus = _useAuthInfo.authStatus,
    isSessionExpired = _useAuthInfo.isSessionExpired;

  // Only mount the authenticated provider tree once we have confirmed auth, or
  // for an expired mid-session (where prior user context is preserved behind the
  // re-auth modal). Any other status — "loggedOut", or "loading" left behind by
  // a transient first-load /api/auth/me failure — falls back to LoggedOutPage so
  // we never render the app shell without a user.
  if (authStatus !== "authenticated" && authStatus !== "expired") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoggedOutPage.default, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AnalyticsContext.AnalyticsContextProvider, {
    "data-sentry-element": "AnalyticsContextProvider",
    "data-sentry-component": "AuthenticatedApp",
    "data-sentry-source-file": "App.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_WordDocumentContext.WordDocumentProvider, {
      "data-sentry-element": "WordDocumentProvider",
      "data-sentry-source-file": "App.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineAuthorColorsContext.RedlineAuthorColorsProvider, {
        "data-sentry-element": "RedlineAuthorColorsProvider",
        "data-sentry-source-file": "App.tsx",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentPageContext.DocumentPageProvider, {
          pages: _anchorTrackerRegistry.documentPages,
          "data-sentry-element": "DocumentPageProvider",
          "data-sentry-source-file": "App.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatContext.ChatProvider, {
            "data-sentry-element": "ChatProvider",
            "data-sentry-source-file": "App.tsx",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProposalEditsContext.ProposalEditsProvider, {
              "data-sentry-element": "ProposalEditsProvider",
              "data-sentry-source-file": "App.tsx",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReviewedDocumentContext.ReviewedDocumentProvider, {
                "data-sentry-element": "ReviewedDocumentProvider",
                "data-sentry-source-file": "App.tsx",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BulkApplyRunContext.BulkApplyRunProvider, {
                  "data-sentry-element": "BulkApplyRunProvider",
                  "data-sentry-source-file": "App.tsx",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SavedPromptsContext.SavedPromptsProvider, {
                    "data-sentry-element": "SavedPromptsProvider",
                    "data-sentry-source-file": "App.tsx",
                    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_SavedFilesContext.SavedFilesProvider, {
                      "data-sentry-element": "SavedFilesProvider",
                      "data-sentry-source-file": "App.tsx",
                      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AddinAiNoticeGate.default, {
                        "data-sentry-element": "AddinAiNoticeGate",
                        "data-sentry-source-file": "App.tsx",
                        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AppContent, {
                          "data-sentry-element": "AppContent",
                          "data-sentry-source-file": "App.tsx"
                        })
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReauthModal.default, {
                        isOpen: isSessionExpired,
                        "data-sentry-element": "ReauthModal",
                        "data-sentry-source-file": "App.tsx"
                      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SessionExpiryLogout.default, {
                        "data-sentry-element": "SessionExpiryLogout",
                        "data-sentry-source-file": "App.tsx"
                      })]
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  });
};
var AppWithAuth = function AppWithAuth() {
  var _usePage = (0, _PageContext.usePage)(),
    currentPage = _usePage.currentPage;
  // Global safety net for dev overlay: prevent hard crash on unhandled rejections
  (0, _react.useEffect)(function () {
    OfficeExtension.config.extendedErrorLogging = true;
    var onUnhandledRejection = function onUnhandledRejection(e) {
      console.error("Unhandled rejection (captured globally):", e.reason);
      (0, _sentryReporter.reportError)(e.reason, {
        extra: {
          component: "App",
          action: "unhandled_rejection"
        }
      });
    };
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return function () {
      return window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);
  var normalizedPage = currentPage.toLowerCase();
  switch (currentPage) {
    case _PageContext.PAGES.icertisAuthPage:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisAuthPage.default, {});
    case _PageContext.PAGES.icertisCallbackPage:
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisCallbackPage.default, {});
    default:
      // Handle case-insensitive fallback for callback page
      if (normalizedPage === "icertiscallbackpage") {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisCallbackPage.default, {});
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AuthenticatedApp, {});
  }
};
var App = function App() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_WopiContext.WopiProvider, {
    "data-sentry-element": "WopiProvider",
    "data-sentry-component": "App",
    "data-sentry-source-file": "App.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_WopiSessionLifecycle.default, {
      "data-sentry-element": "WopiSessionLifecycle",
      "data-sentry-source-file": "App.tsx"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AuthContext.AuthProvider, {
      "data-sentry-element": "AuthProvider",
      "data-sentry-source-file": "App.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AppWithAuth, {
        "data-sentry-element": "AppWithAuth",
        "data-sentry-source-file": "App.tsx"
      })
    })]
  });
};
var _default = exports.default = App;